import React, { useContext, useState } from "react";
import { Button, Container } from "react-bootstrap";
import Logo from "../../Assets/Icon/icon/logo-remove.png";
import DropDownLanguage from "./DropDownLanguage";

import HelloSuperStarLogo from "../../Assets/Images/HelloSuperStarLogo.png";
import axios from "axios";
import { serverInfo } from "../../App";
import { Link, useHistory } from "react-router-dom";
import { PlayArrow } from "@material-ui/icons";
import {useI18n} from "../../i18n";

const Forget = () => {
  const { t } = useI18n();
  const { imageCdnUrl } = useContext(serverInfo);
  const [email, setEmail] = useState("");
  const [buffer, setBuffer] = useState(false);
  const [errorList, setErrorList] = useState([]);
  let history = useHistory();

  const handelSubmitEmail = () => {
      const data = {
        email: email,
      };

      setBuffer(true);
      axios
        .post("/api/user_forget_password", data)
        .then((res) => {
          setBuffer(false);
          if (res.data.status == 200) {
            history.push({
              pathname: "/new-password",

              state: {
                email: email,
              }, // your data array of objects
            });
          }else if(res.data.status == 201){
            errorList['email'] = res.data.message;
          } else {
            setErrorList(res.data.errors); 
          }
        })
        .catch((err) => {
          setBuffer(false);
        });
  };

  return (
    <>
      <div className="bg-img mobileLog ">
        <div className="container-fluid">
          <div className="row d-flex align-items-center">
            <div
              className="col-md-12  mx-auto row d-flex justify-content-between align-items-center"
              style={{ minHeight: "100vh" }}
            >
              <div className="col-md-6 align-items-center ">
                <center>
                  {" "}
                  <div>
                    <img
                      src={HelloSuperStarLogo}
                      alt="Hello Super Star Logo "
                      className="MobileLogoLog"
                    />
                  </div>
                  <div>
                    <Link to="/tutorial">
                      <button className="btn mt-3 TabBtnLog px-4 Virtual">
                        <PlayArrow />
                        <span className="mx-2 ">{t('Virtual_Tour_text')}</span>
                      </button>
                    </Link>
                  </div>
                </center>
              </div>

              <div className="col-md-6 align-items-center ">
                <center>
                  <div className="d-flex align-items-center justify-content-center MobilelogBottom">
                    <div className="wrapperLog LogBgColor">
                      <center className="mt-3">
                        <img src={Logo} alt="" className="img-fluid LogoImg" />
                      </center>
                      <form>
                        <center>
                          {" "}
                          <h4 className=" card-text lead fw-bold text-warning">
                            {t('Forgot_your_password_text')}
                          </h4>
                          <small className="retrieve-text">
                            {t('Enter_your_email_address_Text')}
                          </small>
                        </center>
                        <div className="field">
                          <input
                            type="text"
                            name="email"
                            className="inp-padding"
                            placeholder= {t('Enter_your_email_Text')}
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                          />
                          <span className="code_ic">
                            <i class="fa-solid fa-envelope"></i>
                          </span>
                          <span className="text-danger">{errorList.email}</span>
                        </div>

                        <Button
                          className="btn BtnLogin my-4 w-100"
                          onClick={handelSubmitEmail}
                        >
                          {buffer ? (
                            <>
                              <i className="fas fa-spinner fa-pulse"></i> &nbsp;
                            </>
                          ) : null}
                          {t('Send_Text')}
                        </Button>
                      </form>
                    </div>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>

        <div className="topright text-light">
          <DropDownLanguage />
        </div>
      </div>
    </>
  );
};

export default Forget;
